export default "__VITE_ASSET__1e2a5a3a__"